<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 62 35"
    aria-hidden="true"
  >
    <path
      d="m56.084 7.624 3.156 8.356c-.93-.133-1.86-.3-2.807-.449l-1.778-4.617-1.827
      4.236c-.9-.15-1.777-.2-2.674-.316l3.206-7.309L50.452.034h2.691l1.628
      4.185L56.516.034h2.724zM48.327.034h-2.442v14.485c.8.05 1.628.083 2.442.182zm-4.551
      14.318c-2.226-.149-4.452-.282-6.727-.332V.034h2.491v11.628c1.429.033 2.857.149
      4.236.215zM34.39 5.7v2.49h-3.405v5.664h-2.458V.034H35.5v2.491h-4.514V5.7h3.405zM24.341
      2.525v11.462c-.831 0-1.678 0-2.492.033V2.525h-2.575V.034h7.657v2.491zm-7.757 5.8c-1.1 0-2.392
      0-3.322.051v3.7c1.462-.1 2.924-.216 4.4-.266v2.39l-6.893.549V.034h6.893v2.491h-4.4v3.356c.964
      0 2.442-.05 3.322-.05v2.492zm-13.8-1.4v8.7c-.9.1-1.694.216-2.541.349V.034h2.371l3.238
      9.053V.034h2.492V14.95c-.88.15-1.777.2-2.724.332z"
      transform="translate(1.261 9.494)"
      style="fill:#e50914"
    />
  </svg>
</template>

<script>
export default {
  name: 'NetflixIcon',
};
</script>
